import Modal from "react-bootstrap/Modal";
import React, { useState } from "react";
import { ModalContext } from "../../contexts/ModalContext";
import SubmitButtonWithSpinner from "./SubmitButtonWithSpinner";
import { Button, Form } from "react-bootstrap";

/**
 * Modal to collect an optional justification note before confirming an action
 * (e.g. edit or delete a report line). The note is sent to the API and shown
 * next to the amendment history.
 */
export default function JustificationNoteModal({
  modalTitle,
  message,
  submitBtnText = "Confirmer",
  onConfirm,
  placeholder = "Ex. : Suppression du titre « fumeur » à la demande du patient.",
}) {
  const { hideCurrentModal } = React.useContext(ModalContext);
  const [note, setNote] = useState("");

  async function handleSubmit() {
    const success = await onConfirm(note.trim() || null);
    if (success) {
      hideCurrentModal();
    }
    return success;
  }

  return (
    <>
      <Modal.Header closeButton onHide={() => hideCurrentModal()}>
        <Modal.Title>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {message && <p className="mb-3">{message}</p>}
        <Form.Group>
          <Form.Label>Note justificative (optionnelle)</Form.Label>
          <Form.Control
            as="textarea"
            rows={3}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder={placeholder}
          />
        </Form.Group>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-end gap-2">
        <Button variant="secondary" onClick={() => hideCurrentModal()}>
          Annuler
        </Button>
        <SubmitButtonWithSpinner submitFct={handleSubmit}>
          {submitBtnText}
        </SubmitButtonWithSpinner>
      </Modal.Footer>
    </>
  );
}
